import React from "react";
import VehicleList from "../components/VehicleList";
import { sampleMicrobuses } from "../lib/vehicles";
import { useTranslation } from "../lib/i18n";
import { useSeo } from "../lib/seo";

export default function MicrobusRentPage() {
  const { t, lang } = useTranslation();
  useSeo({ title: t("seoMicrobusesTitle"), description: t("seoMicrobusesDesc"), path: "/microbuses", lang });

  return (
    <VehicleList
      items={sampleMicrobuses}
      routePrefix="microbuses"
      titleKey="microbuses"
      placeholderKey="microbusesPlaceholder"
      imageClass="h-48"
    />
  );
}
